import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { useIsRedesignEnabled } from "@src/appV2/redesign/hooks/useIsRedesignEnabled";
import { Platform } from "@src/mobile/utils/platform";

export function useIsDailyViewEnabled(): boolean {
  const isRedesignEnabled = useIsRedesignEnabled();
  const isDailyViewEnabled = useCbhFlag(CbhFeatureFlag.DAILY_VIEW_ENABLED, {
    defaultValue: false,
  });

  return isRedesignEnabled && (Platform.isMobile || isDailyViewEnabled);
}
